
import api from '@/api/api'
// import router from '@/router/index'
import Md5 from 'js-md5'
import i18n from '@/plugins/i18n'

export default {
  namespaced: true,
  state: {
    id: null,
    nombre: '',
    apellidos: '',
    telefono: '',
    email: '',
    documento: '',
    tipoDocumento: '',
    idioma: '',
    token: '',
    passwordUsoUnico: false,
    roles: [],
    entornos: [],
    rolActivo: null,
    entornoId: 0,
    idubapi: [],
    loaded: false,
    credentials: [],
    rolCliente: false,
    rolAdmin: false,
    rolProveedor: false,
    inmueblesRolCliente: [],
    promosRolCliente: [],
    rolActual: null,
    mostrarPopupCambioIdioma: true
  },
  mutations: {
    setPromosRolCliente (state, payload) {
      state.promosRolCliente = payload
    },
    setInmueblesRolCliente (state, payload) {
      state.inmueblesRolCliente = payload
    },
    setRolCliente (state, payload) {
      state.rolCliente = payload
    },
    setRolAdmin (state, payload) {
      state.rolAdmin = payload
    },
    setRolProveedor (state, payload) {
      state.rolProveedor = payload
    },
    setUsuario (state, payload) {
      state.id = payload.id,
      state.nombre = payload.nombre,
      state.apellidos = payload.apellidos,
      state.telefono = payload.telefono,
      state.email = payload.email,
      state.documento = payload.documento,
      state.tipoDocumento = payload.tipoDocumento,
      state.idioma = payload.idioma,
      state.token = payload.token,
      state.passwordUsoUnico = payload.passwordUsoUnico,
      state.roles = payload.roles
      state.entornos = payload.entornos,
      state.entornoId = payload.entornoId,
      state.rolActivo = payload.rolActivo
    },
    setIdubapi (state, payload) {
      state.idubapi = payload
    },
    setEmail (state, payload) {
      state.email = payload
    },
    setPasswordUsoUnico (state, payload) {
      state.passwordUsoUnico = payload
    },
    setEntornosTrabajo (/* state, payload */) {
      /* state.entornos = payload.entornos
      state.entornoId = payload.entornoId
      state.idubapi = payload.idubapi */
    },
    logOut (state) {
      localStorage.removeItem('usuario', null)
      state.id = null
    },
    loaded (state, payload) {
      state.loaded = payload
    },
    changeRol (state, payload) {
      state.rolActivo = payload
    },
    setCredentials (state, payload) {
      state.credentials = payload
    },
    updatePermisosActorVisitasPV(state, payload) {
      state.idubapi.PERMISOS_ACTOR_VISITAS_PV = payload
    }
  },
  actions: {
    restaurarSesion ({commit}) {
      return new Promise((resolve/* , reject */) => {
        const usuarioJson = localStorage.getItem('usuario')
        const idubapi = localStorage.getItem('idubapi')
        if (usuarioJson !== null) {
          var arrUsuario = JSON.parse(usuarioJson)
          var arrIdubapi = JSON.parse(idubapi)
          commit('setUsuario', arrUsuario)
          commit('setIdubapi', arrIdubapi)

          commit('setCredentials', {
            id_actor: arrUsuario.id,
            token_sesion: arrUsuario.token,
            idubapi: arrIdubapi.idubapi,
            motor: arrIdubapi.motor || '',
            origen: 'WEB',
            flagPswEncript: false
          })
        }
        resolve()
      })
    },
    setearRol ({commit}) {
      return new Promise((resolve/* , reject */) => { 
        const usuarioJson = localStorage.getItem('usuario')
        const idubapi = localStorage.getItem('idubapi')
        if (usuarioJson !== null) {
          var arrUsuario = JSON.parse(usuarioJson)
          var arrIdubapi = JSON.parse(idubapi)
          //arrUsuario
          const idubapiSeleccionada = arrUsuario.entornos.find(x => arrIdubapi.idubapi === x.idubapi)
          if(idubapiSeleccionada.COD_ROLES.includes('PV_ADMINISTRADOR'))
          {
            commit('setRolAdmin', true)
          }
          else
          {
            commit('setRolAdmin', false)
          }
        }
        resolve()
      })
    },
    logIn ({commit, dispatch, rootState}, {usermail, password, tokenOneSignal, browser, platform, codigoClientePrinex}) {
      return new Promise((resolve, reject) => {
        var contrasena, contrasena_es_encriptada, login_tipo_externo

        if(codigoClientePrinex != null) {
          contrasena = password
          contrasena_es_encriptada = false
          login_tipo_externo = 1

        } else {
          contrasena = Md5(password)
          contrasena_es_encriptada = true,
          login_tipo_externo = 0
        }

        api.post('/actor/doLogin', {
          email: usermail,
          password: contrasena,
          password_encriptada: contrasena_es_encriptada,
          token_terminal: tokenOneSignal,
          id_terminal: null,
          desc_modelo_terminal: browser,
          desc_so_terminal: platform,
          cod_cliente_prinex: codigoClientePrinex,
          login_tipo_externo: login_tipo_externo,
          agrupacion: rootState.agrupacionRolProveedor
        })
          .then(response => {
            if (response.data.result === 'NOK') {
              dispatch('logOut')
              if(response.data.message_detail === 'EXPIRED') {
                reject({
                  message: response.data.message,
                  expired: true,
                  userId: response.data.userId
                })
                return
              }
              else {
                var message = response.data.message.replace('<br><br>', '')
                var idioma = localStorage.getItem('i18n')
                if (message == 'El usuario no está definido en el sistema o la contraseña no es correcta.' && idioma != 'es') {
                  if ( idioma == 'en' ) {
                    message = 'The user is not defined in the system or the password is not correct.';
                  }
                  if ( idioma == 'eu' ) {
                    message = 'Erabiltzailea ez dago sisteman definituta edo pasahitza ez da zuzena.';
                  }
                } 
                if (message == 'La cuenta del usuario se encuentra bloqueada.' && idioma != 'es') {
                  if ( idioma == 'en' ) {
                    message = 'The users´s account is locked.';
                  }
                  if ( idioma == 'eu' ) {
                    message = 'Erabiltzailearen kontua blokeatuta dago.';
                  }
                } 
                if (message == 'La cuenta del usuario se encuentra bloqueada por exceso de intentos de login.Puede solicitar una nueva desde la opción Contraseña olvidada.') {
                  if ( idioma == 'en' ) {
                    message = 'The user account is blocked by too many login attempts. You can request a new one from the Forgot Password option.';
                  }
                  if ( idioma == 'eu' ) {
                    message = 'Erabiltzailearen kontua blokeatuta dago gehiegizko saioa hasteko saiakerengatik. Pasahitza ahaztuta aukeran beste bat eska dezakezu.';
                  }
                }
                if (message == 'El usuario no tiene roles asociados para acceder al aplicativo. Solicítelos a su Administrador.') {
                  if ( idioma == 'en' ) {
                    message = 'The user has no associated roles to access the application. Solicítelos a su Administrador.';
                  }
                  if ( idioma == 'eu' ) {
                    message = 'Erabiltzaileak ez du lotutako rolik aplikaziora sartzeko. Eskatu zure Administratzaileari.';
                  }
                }
                reject({
                  message: message
                })
                return
              }
            }
            else if (response.data.result === 'UNICO') {
              reject({
                unico: true,
                userId: response.data.userId
              })
            }

            const agrupacionRolProveedor = rootState.agrupacionRolProveedor || null

            var result = response.data.resultado.result.data.data
            if (!result.COD_ROLES.includes('PV_SUPERVISOR') && !result.COD_ROLES.includes('PV_CLIENTE') && !result.COD_ROLES.includes('PV_PROVEEDOR') && !result.COD_ROLES.includes('PV_ADMINISTRADOR')) {
              dispatch('logOut')
              // eslint-disable-next-line
              reject({
                message: i18n.t('sinPermisosAccesoAplicacion')
              })
              return
            }

            // vamos a comprobar para cada idubapi si tiene algun rol disponible, el primer idubapi que encontremos con rol es al que conectamos
            // si no tiene ningun idubapi con rol disponible no le dejamos acceder
            const entornos = result.entornos
            let roles = result.COD_ROLES
            let idubapi = false
            let sinLicencias = 0
            let sinRoles = 0

            const rolProveedor = result.COD_ROLES.includes('PV_PROVEEDOR')

            for(let i = 0; i < entornos.length; i++) {
            // _.each(entornos, entorno => {

              // si tiene agrupacionRolProveedor solo nos quedamos con los entornos de dicha agrupacion y tiene rol proveedor
              if(agrupacionRolProveedor && entornos[i].agrupacion && entornos[i].agrupacion != agrupacionRolProveedor) {
                return
              }

              let tieneRolProveedor = false
              let tieneRolProveedorSinLicencia = false
              let tieneRolCliente = false
              let tieneRolClienteSinLicencia = false
              let tieneRol = false
              let tieneRolSinLicencia = false
              let tieneRolAdministrador = false
              let tieneRolAdministradorSinLicencia = false

              if(agrupacionRolProveedor) {

                tieneRolProveedor = entornos[i].COD_ROLES.find(obj => obj === 'PV_PROVEEDOR')
                tieneRolProveedorSinLicencia = entornos[i].COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_PROVEEDOR')

              } else {
                tieneRol = entornos[i].COD_ROLES.find(obj => obj === 'PV_SUPERVISOR')
                tieneRolSinLicencia = entornos[i].COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_SUPERVISOR')

                tieneRolCliente = entornos[i].COD_ROLES.find(obj => obj === 'PV_CLIENTE')
                tieneRolClienteSinLicencia = entornos[i].COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_CLIENTE')

                tieneRolProveedor = entornos[i].COD_ROLES.find(obj => obj === 'PV_PROVEEDOR')
                tieneRolProveedorSinLicencia = entornos[i].COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_PROVEEDOR')

                tieneRolAdministrador = entornos[i].COD_ROLES.find(obj => obj === 'PV_ADMINISTRADOR')
                tieneRolAdministradorSinLicencia = entornos[i].COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_ADMINISTRADOR')

              }

              if(rolProveedor && agrupacionRolProveedor) {
                // solo dejamos el rol proveedor
                entornos[i].COD_ROLES = ['PV_PROVEEDOR', 'PV_PROVEEDOR_WEB']
                roles = ['PV_PROVEEDOR', 'PV_PROVEEDOR_WEB']
              }

              if(tieneRol || tieneRolCliente || tieneRolProveedor || tieneRolAdministrador) {
                // si tiene rol le permitimos continuar
                idubapi = entornos[i]
              } else if (tieneRolSinLicencia || tieneRolClienteSinLicencia || tieneRolProveedorSinLicencia || tieneRolAdministradorSinLicencia) {
                sinLicencias = sinLicencias + 1
              } else {
                sinRoles = sinRoles + 1
              }


            }// )

            // si tiene rolproveedor hay que comprobar que tenga el modulo activo
            if(rolProveedor) {
              const moduloProveedorWeb = idubapi.rolProveedorWeb
              const activoRolProveedor = idubapi.rolProveedor

              if(!moduloProveedorWeb || !activoRolProveedor) {
                const mensaje = i18n.t('proveedorWebNoActivo')
                dispatch('logOut')
                reject({
                  message: mensaje
                })
                return
              }

            }


            const rolCliente = result.COD_ROLES.includes('PV_CLIENTE')

            if (response.data.resultado.result.ok) {

              /*** 287631 - ALC  02/01/23  Si el usuario no tiene idioma ponemos uno por defecto*/
              let cod_idioma2 = result.COD_IDIOMA_2
              if(result.COD_IDIOMA_2 === ""){
                switch (localStorage.getItem('i18n')) {
                  case 'es':
                      cod_idioma2 = 'spa'
                    break;
                  case 'en':
                      cod_idioma2 = 'eng'
                    break;
                  case 'eu':
                      cod_idioma2 = 'eus'
                    break;
                }
              }

              const usuario = {
                id: result.ID_ACTOR,
                nombre: result.NOMBRE_ACTOR,
                apellidos: result.APELLIDOS_ACTOR,
                telefono: result.TELEFONO,
                email: result.E_MAIL,
                documento: result.DOCUMENTO_ID,
                tipoDocumento: result.COD_TIPO_DOCUMENTO_ID,
                idioma: cod_idioma2,
                token: result.token_sesion,
                passwordUsoUnico: (rolCliente) ? false : result.PASSWORD_USUARIO_USO_UNICO,
                roles: roles,
                entornoId: result.ID_ENTORNO_SELECCIONADO,
                idubapi: entornos[0].idubapi,
                entornos: result.entornos
              }

              localStorage.setItem('usuario', JSON.stringify(usuario))

              if(!idubapi) {
                const mensaje = (sinRoles === entornos.length) ? i18n.t('sinRol') : i18n.t('sinLicencias')
                dispatch('logOut')
                reject({
                  message: mensaje
                })
                return
              }

              localStorage.setItem('idubapi', JSON.stringify(idubapi))
              commit('setUsuario', usuario)
              commit('setIdubapi', idubapi)
              commit('setCredentials', {
                id_actor: result.ID_ACTOR,
                token_sesion: result.token_sesion,
                idubapi: idubapi.idubapi,
                motor: idubapi.motor || '',
                origen: 'WEB',
                flagPswEncript: false
              })
              resolve(usuario)
            } else {
              reject(result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    logOut ({commit}) {
      return new Promise((resolve/* , reject */) => {
        const env = require('../../../config/prod.env')
        const querystring = require('querystring')
        const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/logoff_fr',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuarioJson.token,
                cod_naturaleza_acceso: 'P',
                id_actor: usuarioJson.id,
                cod_app: 10
              }
            })
          })).then(() => {
            localStorage.removeItem('usuario')
            commit('logOut')
            resolve()
          })
          .catch(() => {
            commit('logOut')
            resolve()
          })
        }
      )
    },
    updateActor ({commit, rootState}, obj) {
      return new Promise((resolve, reject) => {
        api.post('/actor/updateActor', {
          credentials: rootState.login.credentials,
          values: obj
        })
          .then(response => {
            if (response.data.result === 'OK') {
              const usuario = JSON.parse(localStorage.getItem('usuario'))
              usuario.nombre = obj.actorName
              usuario.apellidos = obj.actorSurname
              usuario.telefono = obj.actorPhoneNumber
              usuario.idioma = obj.actorLanguage
              usuario.tipoDocumento = obj.actorDocumentType
              usuario.documento = obj.actorNumDocument
              localStorage.setItem('usuario', JSON.stringify(usuario))
              commit('setUsuario', usuario)
              resolve()
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    resetPassword ({commit}, obj) {
      commit('setEmail', obj.usermail)
      return new Promise((resolve, reject) => {
        const env = require('../../../config/prod.env')
        const querystring = require('querystring')
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/resetear_password_usuario_fr',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                cod_app: 10,
                usermail: obj.usermail
              }
            })
          })).then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              var message = response.data.result.message
              var idioma = localStorage.getItem('i18n')
              if ( message == 'El usuario no existe.' && idioma != 'es') {
                if ( idioma == 'en') {
                  response.data.result.message = 'User doesn´t exist'
                }
                if ( idioma == 'eu' ) {
                  response.data.result.message = 'Erabiltzaile izena ez dago'
                }
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarPassword ({commit, getters}, {password, passwordActual}) {
      return new Promise((resolve, reject) => {
        const env = require('../../../config/prod.env')
        const querystring = require('querystring')
        const usuarioJson = JSON.parse(localStorage.getItem('usuario')) || {}

        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/modificar_password_usuario_fr',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                password_actual: Md5(passwordActual),
                password: Md5(password),
                password_esta_encriptada: true,
                id_actor: usuarioJson.id,
                cod_app: 10
              }
            })
          })).then(response => {
            if (response.data.result.ok) {
              commit('setPasswordUsoUnico', false)
              localStorage.setItem('usuario', JSON.stringify(getters.usuario))
              resolve()
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
        })
    },
    modificarExpiredPassword ({commit, getters}, {password, passwordActual, userId, userMail}) {
      return new Promise((resolve, reject) => {
        const env = require('../../../config/prod.env')
        const querystring = require('querystring')
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/modificar_password_usuario_fr',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                password: Md5(password),
                password_actual: Md5(passwordActual),
                password_esta_encriptada: true,
                id_actor: userId,
                cod_app: 10
              }
            })
          })).then(response => {
            if (response.data.result.ok) {
              commit('setPasswordUsoUnico', false)
              localStorage.setItem('usuario', JSON.stringify(getters.usuario))

              api.post('/actor/doLogin', {
                email: userMail,
                password: Md5(password),
                password_encriptada: true,
                token_terminal: null,
                id_terminal: null,
                desc_modelo_terminal: null,
                desc_so_terminal: null,
                cod_cliente_prinex: null,
                login_tipo_externo: 0
              })
              .then(response => {
                if (response.data.result === 'NOK') {
                  if(response.data.message_detail === 'EXPIRED') {
                    reject({
                      message: response.data.message,
                      expired: true,
                      userId: response.data.userId
                    })
                    return
                  }
                  else {
                    var message = response.data.message.replace('<br><br>', '')
                    var idioma = localStorage.getItem('i18n')
                    if (message == 'El usuario no está definido en el sistema o la contraseña no es correcta.' && idioma != 'es') {
                      if ( idioma == 'en' ) {
                        message = 'The user is not defined in the system or the password is not correct.';
                      }
                      if ( idioma == 'eu' ) {
                        message = 'Erabiltzailea ez dago sisteman definituta edo pasahitza ez da zuzena.';
                      }
                    } 
                    if (message == 'La cuenta del usuario se encuentra bloqueada.' && idioma != 'es') {
                      if ( idioma == 'en' ) {
                        message = 'The users´s account is locked.';
                      }
                      if ( idioma == 'eu' ) {
                        message = 'Erabiltzailearen kontua blokeatuta dago.';
                      }
                    } 
                    reject({
                      message: message
                    })
                    return
                  }
                }
                var result = response.data.resultado.result.data.data
                if (!result.COD_ROLES.includes('PV_SUPERVISOR') && !result.COD_ROLES.includes('PV_CLIENTE') && !result.COD_ROLES.includes('PV_PROVEEDOR') && !result.COD_ROLES.includes('PV_ADMINISTRADOR')) {
                  // eslint-disable-next-line
                  reject({
                    message: i18n.t('sinPermisosAccesoAplicacion')
                  })
                  return
                }
                var rolCliente = result.COD_ROLES.includes('PV_CLIENTE')
                if (response.data.resultado.result.ok) {
                  const usuario = {
                    id: result.ID_ACTOR,
                    nombre: result.NOMBRE_ACTOR,
                    apellidos: result.APELLIDOS_ACTOR,
                    telefono: result.TELEFONO,
                    email: result.E_MAIL,
                    documento: result.DOCUMENTO_ID,
                    tipoDocumento: result.COD_TIPO_DOCUMENTO_ID,
                    idioma: result.COD_IDIOMA_2,
                    token: result.token_sesion,
                    passwordUsoUnico: (rolCliente) ? false : result.PASSWORD_USUARIO_USO_UNICO,
                    roles: result.COD_ROLES,
                    entornoId: result.ID_ENTORNO_SELECCIONADO,
                    idubapi: result.entornos[0].idubapi,
                    entornos: result.entornos
                  }
                  localStorage.setItem('idubapi', JSON.stringify(result.entornos[0]))
                  localStorage.setItem('usuario', JSON.stringify(usuario))
                  commit('setUsuario', usuario)
                  commit('setIdubapi', result.entornos[0])
                  commit('setCredentials', {
                    id_actor: result.ID_ACTOR,
                    token_sesion: result.token_sesion,
                    idubapi: result.entornos[0].idubapi,
                    motor: result.entornos[0].motor,
                    origen: 'WEB',
                    flagPswEncript: false
                  })
                  resolve(usuario)
                } else {
                  reject(result)
                }
              })
              .catch(e => {
                reject(e)
              })
            } else {
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
        })
    },
    comprobarSesion ({commit, dispatch}, usuario) {
      const env = require('../../../config/prod.env')
      const querystring = require('querystring')
      return new Promise((resolve, reject) => {
        api.post(env.CUPE_PATH + 'CUPE_BKND_WS_Admin/chequear_sesion_activa',
          querystring.stringify({
            jsondata: JSON.stringify({
              parametros: {
                token_sesion: usuario.token,
                cod_naturaleza_acceso: 'P',
                img: 1,
                id_actor: usuario.id,
                id_modulo: 1,
                cod_app: 10
              }
            })
          }))
          .then(response => {
            const sesion = response.data.result.ok
            if(sesion === false) {
              commit('logOut')
              if ( usuario.idioma !== 'spa') {
                if ( usuario.idioma == 'eng' ) {
                  dispatch('alerts/add', {texto: 'The session is already closed.', color: 'error'}, {root:true})
                }
                if ( usuario.idioma == 'eus' ) {
                  dispatch('alerts/add', {texto: 'Dagoeneko saioa itxita dago.', color: 'error'}, {root:true})
                }
              }else {
                dispatch('alerts/add', {texto: response.data.result.message, color: 'error'}, {root:true})
              }
            }
            resolve()
          })
          .catch(e => {
            reject(e)
            return e
          })
      })
    },
    cerrarSesion ({commit, dispatch}) {
      commit('logOut')
      dispatch('alerts/add', {texto: i18n.t('sectionLogin.subtitle'), color: 'error'}, {root:true})
    },
    cambiarRolActivo ({commit, getters}) {
      if (getters.rolActivo === 'PERS_COMERCIAL') {
        commit('changeRol', 'PERS_INDUSTRIAL_TECNICO')
      } else {
        commit('changeRol', 'PERS_COMERCIAL')
      }
      localStorage.setItem('usuario', JSON.stringify(getters.usuario))
    },
    cambiarIdubapi ({ commit, dispatch, rootState }) {
      var idubapi = JSON.parse(localStorage.getItem('idubapi'))
      // comprobamos las licencias
      let tieneRol;
      let tieneRolSinLicencia;
      const esAdmin = idubapi.COD_ROLES.find(obj => obj === 'PV_ADMINISTRADOR')
      if(rootState.login.rolCliente) {
        tieneRol = idubapi.COD_ROLES.find(obj => obj === 'PV_CLIENTE')
        tieneRolSinLicencia = idubapi.COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_CLIENTE')
      } else {
        tieneRol = idubapi.COD_ROLES.find(obj => obj === 'PV_SUPERVISOR')
        tieneRolSinLicencia = idubapi.COD_ROLES_SIN_LICENCIAS.find(obj => obj === 'PV_SUPERVISOR')
      }
      // return this.$store.state.login.rolCliente

      if(tieneRol || esAdmin) {
        // si tiene rol le permitimos continuar
        commit('setIdubapi', idubapi)
        if(esAdmin)
        {
          commit('setRolAdmin', true)
        }
        else{
          commit('setRolAdmin', false)
        }
        location.reload()
        return
      } else if (tieneRolSinLicencia) {
        // mostramos mensaje de que el entorno no tiene licencias disponibles
        const mensaje = i18n.t('sinLicencias')
        dispatch('alerts/add', {texto: mensaje, color: 'error'}, {root:true})
      } else {
        const mensaje = i18n.t('sinRol')
        dispatch('alerts/add', {texto: mensaje, color: 'error'}, {root:true})
        // mostramos mensaje de que no tiene rol asignado
      }
    },
    setLoaded ({commit}, payload) {
      commit('loaded', payload)
    },
    enviarMensajePV1 ({commit}, motivos) {
      return new Promise((resolve/* , reject */) => {
        api.post('/varios/enviarMensajePV1', {
          motivos: motivos
        })
          .then((e) => {
            resolve(e)
            commit()
          })
          .catch(/* e */() => {
            resolve()
          })
      })

    }
  },
  getters: {
    usuario (state) {
      return {
        id: state.id,
        nombre: state.nombre,
        apellidos: state.apellidos,
        telefono: state.telefono,
        email: state.email,
        documento: state.documento,
        tipoDocumento: state.tipoDocumento,
        idioma: state.idioma,
        token: state.token,
        passwordUsoUnico: state.passwordUsoUnico,
        roles: state.roles,
        entornos: state.entornos,
        entornoId: state.entornoId,
        rolActivo: state.rolActivo
      }
    },
    idubapi (state) {
      return state.idubapi
    },
    passwordUsoUnico (state) {
      return state.passwordUsoUnico
    },
    loaded (state) {
      return state.loaded
    },
    loggedIn (state) {
      /*
      if (localStorage.getItem("usuario") === null) {
        return false;
      } else {
        return true
      }
      */
      return state.id !== null && state.id.length > 0
    },
    rolProveedor (state) {
      return state.rolProveedor
    },
    rolCliente (state) {
      return state.rolCliente
    }
  }
}
